module.exports = __webpack_public_path__ + "fonts/Inter-500-cyrillic-ext50.857026d.woff2";